import { Table } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledTable = styled(Table)(() => ({
  minWidth: 300,
})) as typeof Table;

export default StyledTable;
